import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import { Component, OnInit, inject } from '@angular/core';
import {
  NonNullableFormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Store } from '@ngrx/store';
import { emailRegexPattern } from 'src/app/models/authentication';
import { loginUser } from 'src/app/reducers/user/user.actions';
import { selectLoginSpinnerState } from 'src/app/reducers/user/user.selectors';
import { IState } from 'src/app/reducers';
import { parseSupportedLanguage } from 'src/app/shared/utils.functions';
import { AsyncPipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { FieldWithErrorsComponent } from '../../shared/components/field-with-errors/field-with-errors.component';
import { FormWithErrorsComponent } from '../../shared/components/form-with-errors/form-with-errors.component';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'resto-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [
    MatCardModule,
    FormWithErrorsComponent,
    FormsModule,
    ReactiveFormsModule,
    FieldWithErrorsComponent,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatIconModule,
    AsyncPipe,
    TranslocoPipe,
  ],
})
export class LoginComponent implements OnInit {
  private fb = inject(NonNullableFormBuilder);
  private ngrxStore = inject<Store<IState>>(Store);
  private translate = inject(TranslocoService);

  loginForm = this.fb.group({
    email: ['', [Validators.required, Validators.pattern(emailRegexPattern)]],
    password: [
      '',
      [Validators.required, Validators.minLength(8), Validators.maxLength(32)],
    ],
  });
  spinnerState$ = this.ngrxStore.select(selectLoginSpinnerState);

  ngOnInit(): void {
    this.translate.setActiveLang(parseSupportedLanguage(navigator.language));
  }

  onSubmit(): void {
    if (this.loginForm.valid) {
      this.ngrxStore.dispatch(loginUser(this.loginForm.getRawValue()));
    }
  }
}
